module.exports = __webpack_public_path__ + "img/egg-4.8828f3a6.svg";